import { UserDetails } from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { useTaskCenterStore } from '@frontend/task-center-scope';
import { AIR_RECEPTIONIST_MOCK_ID } from '../constants';

const AIR: UserDetails = {
  userId: AIR_RECEPTIONIST_MOCK_ID,
  firstName: 'AI',
  lastName: 'Receptionist',
};

export const useGetCreatedByList = () => {
  const { assignees, isAIRCreatorEnabled } = useTaskCenterStore(['assignees', 'isAIRCreatorEnabled']);

  if (isAIRCreatorEnabled) {
    return [AIR, ...assignees];
  }

  return assignees;
};
